module.exports = __webpack_public_path__ + "static/img/r_006.6cebb44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/r_006.jpg
// module id = iHdv
// module chunks = 1